import { constants, mediaQueryStyles } from "@newsela/angelou";

const { mediaQuery } = mediaQueryStyles;
const { BreakpointNames } = constants.breakpoints;
// md is 1024; use 1023 so the button is visible at 1024px (no named breakpoint at 1023)
const HIDE_VIEW_RESOURCES_BELOW_PX = 1023;
export const rootContainerCss = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
};

export const headerActionsContainerStyles = {
  display: "flex",
};

export const bookmarkIconStyles = {
  root: {
    color: constants.colors.ui.neutral[500],
  },
};

export const shareActionWrapperStyles = {
  height: "24px",
  width: "24px",
  position: "relative",
  top: "-2px",
  cursor: "pointer",
  marginLeft: "16px",
  marginBottom: "20px",
} as const;

export const assignmentButtonWrapperCss = {
  marginLeft: "32px",
};

export const popupOverridesStyles = {
  root: {
    zIndex: 3,
  },
};

export const viewResourcesButtonCss = {
  root: {
    width: "fit-content",
    height: "32px",
    [mediaQuery.upTo(HIDE_VIEW_RESOURCES_BELOW_PX)]: {
      display: "none",
    },
    [mediaQuery.downTo(BreakpointNames.md)]: {
      display: "flex",
    },
  },
};
